import axios from "axios";
// let serializedObject = sessionStorage.getItem("userDetails");
// const userDetails = JSON.parse(serializedObject);
const configBaseUrl = process.env.REACT_APP_API_DOMAIN;
export const loginApi = async (credentials) => {
  try {
    const apiData = await axios.post(
      `${configBaseUrl}/user/login`,
      credentials
    );
    if (apiData?.data?.data) {
      const data = apiData.data.data;
      let accessToken = null;
      let refreshToken = null;

      if (data.token) {
        accessToken = data.token.accessToken || data.token.AccessToken;
        refreshToken = data.token.refreshToken || data.token.RefreshToken;
      } else if (data.Token) {
        accessToken = data.Token.AccessToken || data.Token.accessToken;
        refreshToken = data.Token.RefreshToken || data.Token.refreshToken;
      } else {
        accessToken = data.AccessToken || data.accessToken;
        refreshToken = data.RefreshToken || data.refreshToken;
      }

      data.token = {
        accessToken: accessToken,
        refreshToken: refreshToken,
      };

      if (data.user) {
        data.name = data.user.username || data.name;
        data.role = data.user.role || data.role;
      }
      data.email = credentials.email;
    }
    const serializedObject = JSON.stringify(apiData?.data?.data);
    sessionStorage.setItem("userDetails", serializedObject);
    return apiData;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};
export const sendOtpApi = async (credentials) => {
  try {
    const apiData = await axios.post(`${configBaseUrl}/mail/otp`, credentials);
    return apiData;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};

export const verifyOtpApi = async (credentials) => {
  try {
    const email = sessionStorage.getItem("Email");

    const requestBody = {
      email: email,
      otp: credentials,
    };

    const apiData = await axios.post(
      `${configBaseUrl}/mail/verify`,
      requestBody
    );
    return apiData;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};

export const passwordChangeApi = async (credentials) => {
  try {
    const resetToken = sessionStorage.getItem("resetToken");
    let requestBody = {
      newPassword: credentials.newPassword,
      confirmPassword: credentials.confirmPassword,
      resetToken: resetToken
    };
    const apiData = await axios.post(
      `${configBaseUrl}/mail/passwordChange`,
      requestBody
    );
    return apiData;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};

export const dashboartCountApi = async () => {
  try {
    let serializedObject = sessionStorage.getItem("userDetails");
    const userDetails = JSON.parse(serializedObject);
    let token = userDetails.token.accessToken;
    const apiData = await axios.get(
      `${process.env.REACT_APP_API_DOMAIN}/user/userCounts`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    if (apiData?.data) {
      const originalData = apiData.data.data || {};
      const mappedData = {
        totalActiveUsers: originalData.totalActiveUsers ?? 0,
        ducoRegisteredUsers: originalData.ducoRegisteredUsers ?? originalData.ducoActiveUsers ?? 0,
        ducoActiveUsers: originalData.ducoRegisteredUsers ?? originalData.ducoActiveUsers ?? 0,
        migratedFromUiiUsers: originalData.migratedFromUiiUsers ?? originalData.uiiActiveUsers ?? 0,
        uiiActiveUsers: originalData.migratedFromUiiUsers ?? originalData.uiiActiveUsers ?? 0,
        totalGold: originalData.totalGold ?? 0,
        totalPlatinum: originalData.totalPlatinum ?? 0,
        totalSilver: originalData.totalSilver ?? 0,
        totalTrials: originalData.totalTrials ?? 0,
        totalCompanyUsed: originalData.totalCompanyUsed ?? 0,
        totalUsersUII: originalData.totalUsersUII ?? 0,
        totalUsersNIA: originalData.totalUsersNIA ?? 0,
        totalUsersNIC: originalData.totalUsersNIC ?? 0,
        totalUsersOIC: originalData.totalUsersOIC ?? 0,
        totalUserslic: originalData.totalUserslic ?? originalData.totalUsersLIC ?? 0
      };
      apiData.data.data = mappedData;
    }
    console.log(apiData.data);
    return apiData.data;
  } catch (error) {
    console.log(error);
    return error.response?.data || { success: false, message: error.message };
  }
};

export const planDetailsApi = async (
  skip,
  limit,
  searchedData,
  isForSheet,
  startDate,
  endDate
) => {
  try {
    startDate = startDate === null ? "" : startDate;
    endDate = endDate === null ? "" : endDate;

    let serializedObject = sessionStorage.getItem("userDetails");
    const userDetails = JSON.parse(serializedObject);
    let token = userDetails.token.accessToken;
    const apiData = await axios.get(
      `${process.env.REACT_APP_API_DOMAIN}/user/plans`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          skip: skip,
          limit: limit,
          searchedData: searchedData,
          isForSheet: isForSheet,
          fromDate: startDate,
          toDate: endDate,
        },
        responseType: isForSheet === "true" ? "blob" : "json",
      }
    );
    if (apiData?.data) {
      if (isForSheet === "true") {
        const url = window.URL.createObjectURL(new Blob([apiData.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "plan-details.xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
        return {
          statusCode: 200,
          count: 0,
          message: []
        };
      }

      let rawList = Array.isArray(apiData.data.data) ? apiData.data.data : [];
      let count = typeof apiData.data.count === 'number' ? apiData.data.count : rawList.length;

      if (typeof apiData.data.data === 'number' && Array.isArray(apiData.data.count)) {
        rawList = apiData.data.count;
        count = apiData.data.data;
      }

      const mappedList = rawList.map((item, idx) => {
        if (!item || typeof item !== "object") return {};
        return {
          id: item._id || item.id || idx,
          Profile: typeof item.Profile === "string" ? item.Profile : "",
          Name: typeof item.Name === "string" ? item.Name : "",
          DateOfBirth: item.DateOfBirth || "-",
          Mobile: item.Mobile || "",
          Email: item.Email || "",
          Address: item.Address || "-",
          CompanyName: item.CompanyName || "-",
          LastPlanStatus: item.LastPlanStatus || "-",
          LastPlanName: item.LastPlanName || "Trial",
          LastPlanStartDate: item.LastPlanStartDate || "-",
          LastPlanEndDate: item.LastPlanEndDate || "-",
          LastPlanAmount: item.LastPlanAmount || 0,
          LastPlanPurchaseDate: item.LastPlanPurchaseDate || "-",
          PreviousPlanName: item.PreviousPlanName || "-",
          PreviousPlanStartDate: item.PreviousPlanStartDate || "-",
          PreviousPlanEndDate: item.PreviousPlanEndDate || "-",
          PreviousPlanAmount: item.PreviousPlanAmount || "-"
        };
      });
      return {
        statusCode: apiData.data.statusCode || 200,
        count: count,
        message: mappedList
      };
    }
    return {
      statusCode: 200,
      count: 0,
      message: []
    };
  } catch (error) {
    console.log(error);
    return {
      statusCode: error.response?.status || 500,
      count: 0,
      message: []
    };
  }
};

export const getSupportRequestsApi = async (skip, limit, searchedData, status, category, sortBy, sortOrder, startDate, endDate) => {
  try {
    // Retrieve stored user details safely
    const serializedObject = sessionStorage.getItem("userDetails");
    if (!serializedObject) {
      console.warn("[getSupportRequestsApi] No userDetails found in sessionStorage – likely not logged in.");
      return { success: false, error: "Not authenticated" };
    }
    let userDetails;
    try {
      userDetails = JSON.parse(serializedObject);
    } catch (e) {
      console.error("[getSupportRequestsApi] Failed to parse userDetails:", e);
      return { success: false, error: "Corrupted auth data" };
    }
    const token = userDetails?.token?.accessToken;
    if (!token) {
      console.warn("[getSupportRequestsApi] No access token available – authentication required.");
      return { success: false, error: "Missing token" };
    }

    const apiData = await axios.get(
      `${process.env.REACT_APP_API_DOMAIN}/user/support-requests`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          skip,
          limit,
          searchedData,
          status,
          category,
          sortBy,
          sortOrder,
          fromDate: startDate || "",
          toDate: endDate || "",
        },
      }
    );
    // Return the payload directly; callers can check `success` flag if needed
    return apiData?.data;
  } catch (error) {
    console.error(error);
    return error.response?.data || { success: false, message: error.message };
  }
};

export const updateTicketStatusApi = async (ticketId, status, resolutionNotes, category) => {
  try {
    let serializedObject = sessionStorage.getItem("userDetails");
    const userDetails = JSON.parse(serializedObject);
    let token = userDetails.token.accessToken;
    const apiData = await axios.put(
      `${process.env.REACT_APP_API_DOMAIN}/user/support-requests/${ticketId}`,
      { status, resolutionNotes, category },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return apiData?.data;
  } catch (error) {
    console.error(error);
    return error.response?.data || { success: false, message: error.message };
  }
};

export const userDetailsApi = async (mobile) => {
  try {
    let serializedObject = sessionStorage.getItem("userDetails");
    const userDetails = JSON.parse(serializedObject);
    let token = userDetails.token.accessToken;
    const apiData = await axios.get(
      `${process.env.REACT_APP_API_DOMAIN}/user/oneUserDetails`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          mobile: mobile,
        },
      }
    );
    return apiData?.data;
  } catch (error) {
    console.error(error);
    return error.response?.data || { success: false, message: error.message };
  }
};

export const manualUpdateApi = async (mobile, planName, planAmount) => {
  try {
    let serializedObject = sessionStorage.getItem("userDetails");
    const userDetails = JSON.parse(serializedObject);
    let token = userDetails.token.accessToken;
    const apiData = await axios.post(
      `${process.env.REACT_APP_API_DOMAIN}/plan/manualUpdate`,
      {
        planname: planName,
        planamount: Number(planAmount),
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          mobile: mobile,
        },
      }
    );
    return apiData?.data;
  } catch (error) {
    console.error(error);
    return error.response?.data || { success: false, message: error.message };
  }
};

export const deleteOnePlanApi = async (mobile) => {
  try {
    let serializedObject = sessionStorage.getItem("userDetails");
    const userDetails = JSON.parse(serializedObject);
    let token = userDetails.token.accessToken;
    const apiData = await axios.delete(
      `${process.env.REACT_APP_API_DOMAIN}/user/deleteOnePlan`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          mobile: mobile,
        },
      }
    );
    return apiData?.data;
  } catch (error) {
    console.error(error);
    return error.response?.data || { success: false, message: error.message };
  }
};

export const csvReadApi = async (file) => {
  try {
    let serializedObject = sessionStorage.getItem("userDetails");
    const userDetails = JSON.parse(serializedObject);
    let token = userDetails.token.accessToken;
    const formData = new FormData();
    formData.append("csv", file);
    const apiData = await axios.post(
      `${process.env.REACT_APP_API_DOMAIN}/plan/csvRead`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return apiData?.data;
  } catch (error) {
    console.error(error);
    return error.response?.data || { success: false, message: error.message };
  }
};

export const getAllVersionsApi = async () => {
  try {
    let serializedObject = sessionStorage.getItem("userDetails");
    const userDetails = JSON.parse(serializedObject);
    let token = userDetails.token.accessToken;
    const apiData = await axios.get(
      `${process.env.REACT_APP_API_DOMAIN}/forceupdate/allVersion`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return apiData?.data;
  } catch (error) {
    console.error(error);
    return error.response?.data || { success: false, message: error.message };
  }
};

export const postVersionApi = async (versionData) => {
  try {
    let serializedObject = sessionStorage.getItem("userDetails");
    const userDetails = JSON.parse(serializedObject);
    let token = userDetails.token.accessToken;
    const apiData = await axios.post(
      `${process.env.REACT_APP_API_DOMAIN}/forceupdate/versionpost`,
      versionData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return apiData?.data;
  } catch (error) {
    console.error(error);
    return error.response?.data || { success: false, message: error.message };
  }
};

export const updateVersionApi = async (versionData) => {
  try {
    let serializedObject = sessionStorage.getItem("userDetails");
    const userDetails = JSON.parse(serializedObject);
    let token = userDetails.token.accessToken;
    const apiData = await axios.post(
      `${process.env.REACT_APP_API_DOMAIN}/forceupdate/updateVersion`,
      versionData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return apiData?.data;
  } catch (error) {
    console.error(error);
    return error.response?.data || { success: false, message: error.message };
  }
};

export const deleteVersionApi = async (appName) => {
  try {
    let serializedObject = sessionStorage.getItem("userDetails");
    const userDetails = JSON.parse(serializedObject);
    let token = userDetails.token.accessToken;
    const apiData = await axios.delete(
      `${process.env.REACT_APP_API_DOMAIN}/forceupdate/deleteOne`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: {
          AppName: appName,
        },
      }
    );
    return apiData?.data;
  } catch (error) {
    console.error(error);
    return error.response?.data || { success: false, message: error.message };
  }
};

export const triggerDailyTransactionsDigestApi = async (startDate, endDate, sendEmail = false) => {
  try {
    let serializedObject = sessionStorage.getItem("userDetails");
    const userDetails = JSON.parse(serializedObject);
    let token = userDetails.token.accessToken;
    const apiData = await axios.post(
      `${process.env.REACT_APP_API_DOMAIN}/plan/daily-transactions-digest`,
      {
        startDate: startDate || null,
        endDate: endDate || null,
        sendEmail: sendEmail,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return apiData?.data;
  } catch (error) {
    console.error(error);
    return error.response?.data || { success: false, message: error.message };
  }
};

export const getSupportStatsApi = async () => {
  try {
    let serializedObject = sessionStorage.getItem("userDetails");
    const userDetails = JSON.parse(serializedObject);
    let token = userDetails.token.accessToken;
    const apiData = await axios.get(
      `${process.env.REACT_APP_API_DOMAIN}/user/support-requests/stats`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return apiData?.data;
  } catch (error) {
    console.error(error);
    return error.response?.data || { success: false, message: error.message };
  }
};
